<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Menus</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Menus</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
    <div class="col-lg-12">
      <!-- <app-button (click)="openCreateOrgDialog()" text="Create Organisation"></app-button> -->
      <p>List of organisations below:</p>

      <hr />

      <mat-form-field appearance="fill">
        <mat-label>Organisations</mat-label>
        <mat-select (valueChange)="onOrgSelect($event)">
          <mat-option *ngFor="let org of organisations" [value]="org">{{
            org.name
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="selectedOrganisation">
        <br />
        <mat-divider></mat-divider>
        <br />
        <h1>User Menu</h1>

        <div class="drag-n-drop-container">
          <h2>Primary</h2>
          <div
            cdkDropList
            #menuUserPrimary="cdkDropList"
            [cdkDropListData]="userMenuPrimary"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of userMenuPrimary"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, userMenuPrimary)
                    "
                    >delete
                  </mat-icon>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>Secondary</h2>
          <div
            cdkDropList
            #menuUserSecondary="cdkDropList"
            [cdkDropListData]="userMenuSecondary"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of userMenuSecondary"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, userMenuSecondary)
                    "
                    >delete
                  </mat-icon>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>MobileLeftNavBar</h2>
          <div
            cdkDropList
            #menuUserMobileLeftNavBar="cdkDropList"
            [cdkDropListData]="userMenuMobileLeftNavBar"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of userMenuMobileLeftNavBar"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, userMenuMobileLeftNavBar)
                    "
                  >
                    delete</mat-icon
                  >
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>MobileRightNavBar</h2>
          <div
            cdkDropList
            #menuUserMobileRightNavBar="cdkDropList"
            [cdkDropListData]="userMenuMobileRightNavBar"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of userMenuMobileRightNavBar"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, userMenuMobileRightNavBar)
                    "
                    >delete</mat-icon
                  >
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>Menu List</h2>
          <div
            cdkDropList
            #userList="cdkDropList"
            [cdkDropListData]="menuListUser"
            [cdkDropListConnectedTo]="[
              menuUserPrimary,
              menuUserSecondary,
              menuUserMobileLeftNavBar,
              menuUserMobileRightNavBar
            ]"
            cdkDropListSortingDisabled
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of menuListUser"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <br />

        <button
          mat-button
          class="btn btn-primary"
          (click)="updateMenus(); saveUserMenu()"
          [disabled]="!selectedOrganisation"
        >
          Save
        </button>
        <br />
        <br />
        <mat-divider></mat-divider>
        <br />
        <h1>Admin Menu</h1>

        <div class="drag-n-drop-container">
          <h2>Primary</h2>

          <div
            cdkDropList
            #menuAdminPrimary="cdkDropList"
            [cdkDropListData]="adminMenuPrimary"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of adminMenuPrimary"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, adminMenuPrimary)
                    "
                    >delete
                  </mat-icon>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>Secondary</h2>

          <div
            cdkDropList
            #menuAdminSecondary="cdkDropList"
            [cdkDropListData]="adminMenuSecondary"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of adminMenuSecondary"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, adminMenuSecondary)
                    "
                    >delete
                  </mat-icon>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>MobileLeftNavBar</h2>

          <div
            cdkDropList
            #menuAdminMobileLeftNavBar="cdkDropList"
            [cdkDropListData]="adminMenuMobileLeftNavBar"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of adminMenuMobileLeftNavBar"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, adminMenuMobileLeftNavBar)
                    "
                    >delete</mat-icon
                  >
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>MobileRightNavBar</h2>

          <div
            cdkDropList
            #menuAdminMobileRightNavBar="cdkDropList"
            [cdkDropListData]="adminMenuMobileRightNavBar"
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of adminMenuMobileRightNavBar"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                  <mat-icon
                    color="warn"
                    (click)="
                      $event.stopPropagation();
                      deleteItem(item, adminMenuMobileRightNavBar)
                    "
                    >delete</mat-icon
                  >
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <div class="drag-n-drop-container">
          <h2>Menu List</h2>

          <div
            cdkDropList
            #adminList="cdkDropList"
            [cdkDropListData]="menuListAdmin"
            [cdkDropListConnectedTo]="[
              menuAdminPrimary,
              menuAdminSecondary,
              menuAdminMobileLeftNavBar,
              menuAdminMobileRightNavBar
            ]"
            cdkDropListSortingDisabled
            class="drag-n-drop-list"
            (cdkDropListDropped)="drop($event)"
          >
            <div
              class="drag-n-drop-box"
              *ngFor="let item of menuListAdmin"
              cdkDrag
            >
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div *ngIf="item.text">{{ item.text.fr }}</div>
                  </mat-panel-title>
                  <mat-panel-description>
                    <div *ngIf="item.text">{{ item.text.en }}</div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <ngx-json-viewer
                  [json]="item"
                  [expanded]="false"
                ></ngx-json-viewer>
              </mat-expansion-panel>
            </div>
          </div>
        </div>

        <br />

        <button
          mat-button
          class="btn btn-primary"
          (click)="updateMenus(); saveAdminMenu()"
          [disabled]="!selectedOrganisation"
        >
          Save
        </button>
        <br />
        <br />
      </div>
    </div>
  </div>
</section>
<!-- /.content -->
